// frontend/src/features/adhesives/AdhesivesPage.tsx
import React, { useEffect, useState } from "react";
import { Layers2, Download, Info, AlertTriangle, CheckCircle } from "lucide-react";
import { AdhesivesForm } from "./AdhesivesForm";
import { AdhesiveResult } from "./AdhesiveResult";

export default function AdhesivesPage() {
  const [list, setList] = useState<any[]>([]);
  const [result, setResult] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    fetch("/api/adhesives/list")
      .then(r => {
        if (!r.ok) throw new Error("Failed to fetch adhesives");
        return r.json();
      })
      .then(d => {
        setList(d.adhesives || []);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-zinc-900 text-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600 to-teal-500 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-white/10 backdrop-blur-sm rounded-lg">
              <Layers2 className="w-12 h-12 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white">Moduł Klejenia Krawędziowego</h1>
              <p className="text-white/90 mt-1">Profesjonalny dobór klejów i parametrów procesu</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Formularz */}
          <div>
            <div className="bg-zinc-800 rounded-xl p-6 mb-6">
              <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
                <Info className="w-5 h-5 text-green-500" />
                Parametry Klejenia
              </h2>
              
              {loading && (
                <div className="text-center py-8">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500 mx-auto"></div>
                  <p className="mt-4 text-zinc-400">Ładowanie danych...</p>
                </div>
              )}
              
              {error && (
                <div className="bg-red-500/20 border border-red-500 rounded-lg p-4 mb-4">
                  <p className="text-red-400">Błąd: {error}</p>
                </div>
              )}
              
              {!loading && !error && (
                <AdhesivesForm adhesives={list} onChecked={setResult} />
              )}
            </div>

            {/* Informacje o module */}
            <div className="bg-zinc-800/50 rounded-lg p-4 text-sm text-zinc-400">
              <h3 className="font-semibold text-zinc-300 mb-2">O module</h3>
              <ul className="space-y-1">
                <li>• Baza profesjonalnych klejów do tworzyw (PMMA, PC, PET-G, HIPS)</li>
                <li>• Obliczenia wytrzymałości połączeń klejonych</li>
                <li>• Generowanie kart technologicznych PDF</li>
                <li>• Zgodność z normami BHP i wymaganiami produkcyjnymi</li>
              </ul>
            </div>
          </div>

          {/* Wyniki */}
          <div>
            {result && <AdhesiveResult data={result} />}
          </div>
        </div>
      </div>
    </div>
  );
}
